import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertInlineListComponent from './advertInlineList.component';

let advertInlineListModule = angular.module('advertInlineList', [
  uiRouter
])

.component('advertInlineList', advertInlineListComponent)

.name;

export default advertInlineListModule;
